var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArticle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 85,
    viewBox: "0 0 68 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99984 0.833374C4.4165 0.833374 0.708172 4.58337 0.708172 9.16671L0.666504 75.8334C0.666504 80.4167 4.37484 84.1667 8.95817 84.1667H58.9998C63.5832 84.1667 67.3332 80.4167 67.3332 75.8334V29.2917C67.3332 27.0834 66.4582 24.9584 64.8748 23.4167L44.7498 3.29171C43.2082 1.70837 41.0832 0.833374 38.8748 0.833374H8.99984ZM38.1665 25.8334V7.08337L61.0832 30H42.3332C40.0415 30 38.1665 28.125 38.1665 25.8334Z",
    fill: "#C0392B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticle);
export default __webpack_public_path__ + "static/media/Article.b97732e65f566f3dd9ae6d710b81408e.svg";
export { ForwardRef as ReactComponent };